 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"3bb27b3","1":"bf4949b","2":"fe3b780","3":"12cc961","4":"1b87041","5":"a26ab87","6":"a14d712","7":"e044ce5","8":"fbce47b","9":"d5da7fa","10":"f26e502","11":"58e77c9","12":"5fc7d9e","13":"514a002","14":"ee34637","15":"8d0a305","16":"04795d9","17":"58f9e7b","18":"a26ca49","19":"96ec126","20":"65b3078","21":"e926704","22":"4019b91","23":"08e6ffa","24":"2d4b3d0","25":"7232a97","26":"825ff03","27":"55557f0","28":"feafa05","29":"3206486","30":"6c1f7d0","31":"78fe7cf","32":"04a244c","33":"6c35385","34":"f3be9bd","35":"f3575cd","36":"0bffbbf","37":"84a60b8","38":"5d2ce35","39":"6a2e3ca","40":"d64df44","41":"8d89f12","42":"e53285a","43":"17e75f6","44":"48e9dfc","45":"03eed65","46":"0b8571b","47":"77c4a85","48":"42c2fd2","49":"089309f","50":"72a4af9","51":"0084ce3","52":"12224e5","53":"e2b66da","54":"612f7cc","55":"32455f9","56":"0c365aa","57":"a24695e","58":"4718ec3","59":"f6e2dbd","60":"bf763f0","61":"b385fd7","62":"e1cb88e","63":"ed76ec9","64":"da394e8","65":"b50c989","66":"e6ccd5c","67":"93e4458","68":"6c1a9e5","69":"2d0bf87","70":"1d13b98","71":"e58ada0","72":"fdd0ac0","73":"b162a8f","74":"8896edb","75":"ef3d714","76":"5901de5","77":"412ab80","78":"6140df2","79":"7107d1b","80":"f3a53ec","81":"a1f3f33","82":"5f69aff","83":"72182d0","84":"2c5fa8e","85":"4049b8b","86":"023019e","87":"7113e81","88":"6b9865c","89":"daccfc0","90":"99d3cee","91":"0bbf743","92":"f3fffd6","93":"0ad0811","94":"15be2bc","95":"7ea7a37","96":"dc3c16b","97":"1892fcc","98":"c906e6b","99":"6e057f6","100":"273bc6f","101":"8a8aad9","102":"9711a7b","103":"26816b6","104":"46c17f5","105":"d1f4996","106":"9b42327","107":"d6c151b","110":"2e852c6","111":"d9e8537","112":"061003b","113":"b373e2c","114":"c4701e1","115":"f1f2ce2","116":"ea02a09","117":"a5a83fa","118":"108ff0d","119":"12a9965","120":"2f3bee3","121":"b3ec1d0","122":"b626ff5","123":"5f6ef7d","124":"5f70d05","125":"391776c","126":"9767395","127":"1f8daf6","128":"4ac9500","129":"8daa7ee","130":"1b45a63","131":"975d3bf","132":"f1bfa60","133":"74c88ba","134":"b43f33e","135":"3bb0237","136":"bfed9c5","137":"9623390","138":"8ff5610","139":"2930266","140":"7c2dc3e","141":"e30b284","142":"cc7a3e5","143":"2fddf5c","144":"37863db","145":"5d054a9","146":"a23375e","147":"afb1698","148":"c28bb1c","149":"745584a","150":"0a330d7","151":"00631e4","152":"6ccb17e","153":"2bd7473","154":"40c62c9","155":"c75d074","156":"51029e8","157":"d6b19b2","158":"2bf762d","159":"8c16777","160":"8847adc","161":"e21c0d2","162":"1e820dd","163":"3db7222","164":"025a847","165":"140c43b","166":"ab2105c","167":"a02dbfb","168":"05c7949","169":"35383e7","170":"3c67e5e","171":"06b5c67","172":"b669385","173":"580a6ae","174":"aea8b31","175":"9435ca8","176":"b3cc993","177":"f6ef1d4","178":"42a39cc","179":"bdd32ef","180":"877d89f","181":"b86772b","182":"ddbe7a5","183":"7d68ba2","184":"54ecd64","185":"c353a5e","186":"e6e4b3b","187":"4dd89cf","188":"085f80b","189":"09b626d","190":"fa70e6a","191":"48ffc78","192":"f0c73d7","193":"d25f3e8","194":"fe19e81","195":"1c8868a","196":"8841a21","197":"b82752b","198":"8003883","199":"33c7bcc","200":"b1ae6ac","201":"5e97d08","202":"bf50112","203":"551fdcc","204":"5cd6d3b","205":"2ece8b1","206":"cf52dc8","207":"25cc94e","208":"e5ad4f8","209":"5934ee8","210":"ed3ea4b","211":"0d9d099","212":"011a782","213":"5c81bc5","216":"8f3130c","217":"4e6cfb0","218":"6259657","219":"337235b","220":"56e7560","221":"5e87556","222":"e017d76","223":"0fdc422","224":"5b01dd3","225":"6f0b276","226":"4f5f9b8","227":"ce20ffd","228":"67f547a","229":"b2e7d70","230":"091d940","231":"58afdd5","232":"070b891","233":"4af8475","234":"15b067e","235":"8398bd6","236":"4f812ec","237":"4ce6310","238":"321f9e2","239":"f51c814","240":"d92e409","241":"f202864","242":"b3e5371","243":"6ff3846","244":"5e97272","245":"4c3b90e","246":"1c71981","247":"03dd553","248":"836afdf","249":"282a532","250":"f9dbe7d","251":"d5def0c","252":"4b21bc5","253":"3d715df","254":"5fe916d","255":"d6a64cf","256":"37a4cba","257":"633f9f7","258":"5be4616","259":"8b8d486","260":"a8b9fc0","261":"faf254d","262":"612f4d9","263":"452762e","264":"6af8020","265":"3d4ead1","266":"a11cdf9","267":"b71eba4","268":"90e8f71","269":"193cbc4","270":"5e414cf","271":"e7c8c55","272":"03de769","273":"c9ef91a","274":"5758e57","275":"67ec3a5","276":"d701e2b","277":"6627d1c","278":"403c549","279":"31b1742","280":"2793a29","281":"e221ac3","282":"c92f6ad","283":"e7dc3d4","284":"bf401eb","285":"692213a","286":"721aaa5","287":"cddc9ba","288":"b9c13b4","289":"489b3dc","290":"bd492ee","291":"5c37ffc","292":"93aedd6","293":"3fc8e01","294":"28fb37b","295":"bdd1a90","296":"3335ad8","297":"a67c94b","298":"263c9a0","299":"0962bf0","300":"3e5ec94","301":"5ad9f1a","302":"df376dd","303":"2c933ad","304":"e24b262","305":"8e00b4e","306":"ea8f9b8","307":"425753d","308":"074bd24","309":"19f0923","310":"3e8bb9c","311":"78cb716","312":"73ee443","313":"c8095f0","314":"3da7a8b","315":"10231fd","316":"3529bdb","317":"150faaa","318":"86ab1d3","319":"7f84c62","320":"7295540","321":"09a39df","322":"8d5e568","323":"9e17387","324":"5fa87d9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
